import { render, staticRenderFns } from "./termWiseMarkentry.vue?vue&type=template&id=085a7197&"
import script from "./termWiseMarkentry.vue?vue&type=script&lang=js&"
export * from "./termWiseMarkentry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports